module.exports = __webpack_public_path__ + "static/assets/30a6f7999e953ac555ef16d170155429.svg";